"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBadgeText = exports.ProviderBadges = void 0;
var ProviderBadges_1 = require("./ProviderBadges");
Object.defineProperty(exports, "ProviderBadges", { enumerable: true, get: function () { return __importDefault(ProviderBadges_1).default; } });
__exportStar(require("./ProviderBadges"), exports);
var utils_1 = require("./lib/utils");
Object.defineProperty(exports, "formatBadgeText", { enumerable: true, get: function () { return utils_1.formatBadgeText; } });
//# sourceMappingURL=index.js.map